export default function updateSJCards() {
    // attach styles to course-catalog page cards, based on data tags
    try {
        let catalogCards = document.querySelectorAll('.search-filter-page #catalog-courses a.coursebox-container.course');
        for (let card of catalogCards) {
            for (let tag of card.attributes['data-tags'].value.split(',')) {
                card.classList.add('tag-' + tag);
            }
        }
    } catch {
    }

    // update ribbon text
    try {
        let completedRibbons = document.querySelectorAll('.sj-ribbon-complete .sj-ribbon-text');
        for (let ribbon of completedRibbons) {
            ribbon.innerText = 'Completed';
        }
    } catch {
    }
    
    try {
        let registeredRibbons = document.querySelectorAll('.sj-ribbon-registered .sj-ribbon-text');
        for (let ribbon of registeredRibbons) {
            ribbon.innerText = 'In Progress';
        }
    } catch {
    }
    
    // inject 'View Course' buttons into course cards (NOT on landing page)
    if (!document.body.classList.contains("home-page")) {
        try {
            let courseCards = document.querySelectorAll('#catalog-courses.course-listing a');
            for (let card of courseCards) {
                let viewCoursesBtn = document.createElement('div');
                viewCoursesBtn.innerText = 'View';
                viewCoursesBtn.classList.add('coursebox-callout');
                card.appendChild(viewCoursesBtn);
            }
        } catch {
        }
    }
};










